import { SweepsWinnersList } from "./WinnersList";
import { SweepsSearch, SweepsLoader } from "./SweepsSearch";
import { useSetfanSweeps } from "./hooks/useSetfanSweeps";
import { SurveyTypesenseDocument } from "@max/common/setfan";

export const SweepsCard = ({
  survey,
}: {
  survey?: SurveyTypesenseDocument;
}) => {
  const { activeSweeps, loading: loadingMostRecentSweeps } = useSetfanSweeps({
    surveyId: survey?.id,
  });

  if (
    loadingMostRecentSweeps ||
    !survey ||
    activeSweeps?.status === "initialized"
  ) {
    return <SweepsLoader />;
  }

  if (
    activeSweeps?.status === "replacing" ||
    activeSweeps?.status === "sampled"
  ) {
    return <SweepsWinnersList />;
  }

  return <SweepsSearch />;
};
